import React, { useEffect, useState } from "react";
import { Col, Container, Modal, Row, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import {
  gtmChooseLoginToOrder,
  gtmLogin,
  gtmOTPVerify,
  gtmSignUp,
} from "../lib/google-tag-manager";
import { connect } from "react-redux";
import { getUserAuth, setAuth } from "../redux/actions/loginAction";
import { isMobile } from "react-device-detect";
import { UserLoginApi, UserSignUpApi, VerifyOtpApi } from "actions/Auth";
import VerifyOTP from "components/auth/VerifyOTP";
import Layout from "layouts/Layout";
import router from "next/router";
import Head from "next/head";
import API from "api";

const SignUpPage = ({ getUserAuth, setAuth }) => {
  const [isLoginSection, setIsLoginSection] = useState(false);
  const [otpValid, setOtpValid] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [verifyOtpSection, setVerifyOtpSection] = useState(false);
  const [show, setShow] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors, isSubmitting },
    clearErrors,
  } = useForm();

  const onLoginSubmit = async (formData) => {
    console.log("sdjfsdfkjsdlfkjsdklj");
    const response = await UserLoginApi(formData);
    const data = response;
    if (data.IsSuccess) {
      setPhoneNumber(data.Data?.PhoneNumber);
      localStorage.setItem("phoneNumber", data.Data?.PhoneNumber);
      setVerifyOtpSection(true);
      setOtpValid("");
      setValue("otp", "");
      clearErrors("otp");
      gtmLogin();
    } else {
      toast.dismiss();
      toast.error("User Authentication Failed. Please retry.");
    }
  };

  const onOTPVerify = async (formData) => {
    formData = {
      username: formData.phoneNumber,
      password: formData.otp,
      grant_type: "password",
      provider_type: "OTP",
    };
    try {
      const response = await VerifyOtpApi(formData);
      if (response?.status == 400) {
        setOtpValid("Invalid OTP");
        toast.dismiss();
        toast.error("Invalid OTP! Please retry.");
        return;
      }
      localStorage.setItem("login_access", JSON.stringify(response.data));
      setPhoneNumber("");
      await setAuth(response.data);
      await getUserAuth();
      router.push("/");
      toast.dismiss();
      toast.success("Account Logged in Successfully!");
      gtmOTPVerify();
    } catch (err) {
      console.log("Error:", err);
      toast.dismiss();
      toast.error("Something went wrong! Please retry.");
    }
  };

  const resendOtp = async (formData) => {
    const response = await UserLoginApi(formData);
    const data = response;
    if (data.IsSuccess) {
      toast.dismiss();
      toast.success("OTP Resent Successfully!");
    } else {
      toast.dismiss();
      toast.error("OTP Resending Failed. Please retry.");
    }
  };

  const removePrefixPostfixSpaces = (inputString) => {
    while (inputString.startsWith(" ")) {
      inputString = inputString?.slice(1);
    }
    while (inputString.endsWith(" ")) {
      inputString = inputString?.slice(0, -1);
    }
    return inputString;
  };

  const onSignUpSubmit = async (formData) => {
    const FullName = removePrefixPostfixSpaces(formData.FullName);
    const LastName = removePrefixPostfixSpaces(formData.LastName);
    const payload = { ...formData, FullName, LastName };
    const response = await UserSignUpApi(payload);
    const data = response;
    if (!data.IsSuccess) {
      toast.dismiss();
      toast.error(data?.Message || "Something went wrong! Please retry.");
    } else {
      setPhoneNumber(data?.Data?.PhoneNumber);
      gtmSignUp();
      setVerifyOtpSection(true);
      setShow(true);
    }
  };

  const onHide = () => {
    setShow(false);
    setVerifyOtpSection(false);
    setIsLoginSection(false);
  };

  useEffect(() => {
    const init = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("login_access"));
        const headers = {
          "Content-Type": "application/x-www-form-urlencoded",
        };

        if (token?.access_token) {
          headers.Authorization = `Bearer ${token.access_token}`;
        }

        const response = await fetch(
          `${process.env.NEXT_PUBLIC_API_URL}v2/api/customers/auth`,
          {
            method: "GET",
            headers: headers,
          }
        );

        const data = await response.json();
        console.log("Response: ", data);
        if (data?.Data) window.location.href = window.location.origin;
      } catch (error) {
        console.log("sdfjsdflksdfjlk", error);
      }
    };
    init();
  }, []);
  return (
    <Layout title={"Sign Up"}>
      <Head>
        <title>Open Bonnet - Sign Up</title>
        <meta
          name="description"
          content="Sign Up to world class service with Open Bonnet."
        />
        <meta property="og:title" content="Open Bonnet - Sign Up" />
        <meta
          property="og:description"
          content="Sign Up to world class service with Open Bonnet."
        />
      </Head>
      <Container className="sign-up-page position-relative">
        {!isLoginSection && !verifyOtpSection ? (
          <div
            className="custom-modal-signup"
            style={{ zIndex: "inherit !important" }}
          >
            <div className="modal-content">
              <div className="modal-header new-background-gradient text-white new-header">
                <div className="w-100">
                  <p className="new-fw-bold" style={{ fontSize: "22px" }}>
                    SIGN UP
                  </p>
                  <p className="">Earn AED 25 OB CashPoints </p>
                  <p className="">Use Referral Code - "HELLO"</p>
                </div>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit(onSignUpSubmit)}>
                  <div
                    style={{ paddingLeft: "0px" }}
                    className="container text-center"
                  >
                    <img
                      src="/assets/user.svg"
                      alt="logo"
                      width={120}
                      className=""
                    />
                    <div className="d-flex">
                      <div
                        className=" w-50 auth-validation-div custom-validation-auth"
                        style={{
                          height: "40px",
                          padding: "8px",
                          margin: "10px 5px 5px 10px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          border: "1px solid #000",
                          borderRadius: "20px",
                          marginBottom: "11px !important",
                        }}
                      >
                        <input
                          type="text"
                          placeholder=" First Name"
                          style={{ border: "none" }}
                          className="w-100 text-center-mobile"
                          {...register("FullName", { required: true })}
                          onKeyPress={(event) => {
                            if (/\d/.test(event.key)) {
                              // test if the pressed key is a number
                              event.preventDefault(); // prevent the input of numeric values
                            }
                          }}
                          onPaste={(event) => {
                            const clipboardData =
                              event.clipboardData || window.clipboardData;
                            const pastedData = clipboardData.getData("text");
                            if (/\d/.test(pastedData)) {
                              // test if the clipboard contents contain numeric values
                              event.preventDefault(); // prevent the paste operation
                            }
                          }}
                        />
                        {errors?.FullName || errors?.LastName ? (
                          <span
                            className="text-danger auth-validation-span"
                            style={{ width: "250px", textAlign: "start" }}
                          >
                            First Name and Last Name are required
                          </span>
                        ) : null}
                      </div>
                      <div
                        className="w-50 auth-validation-div custom-margin custom-validation-auth"
                        style={{
                          height: "40px",
                          padding: "8px",
                          margin: "10px 30px 5px 5px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          border: "1px solid #000",
                          borderRadius: "20px",
                          marginBottom: "0px !important",
                        }}
                      >
                        <input
                          type="text"
                          placeholder=" Last Name"
                          style={{ border: "none" }}
                          className="w-100 text-center-mobile"
                          {...register("LastName", { required: true })}
                          onKeyPress={(event) => {
                            if (/\d/.test(event.key)) {
                              // test if the pressed key is a number
                              event.preventDefault(); // prevent the input of numeric values
                            }
                          }}
                          onPaste={(event) => {
                            const clipboardData =
                              event.clipboardData || window.clipboardData;
                            const pastedData = clipboardData.getData("text");
                            if (/\d/.test(pastedData)) {
                              // test if the clipboard contents contain numeric values
                              event.preventDefault(); // prevent the paste operation
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div
                      className="auth-validation-div"
                      style={{
                        height: "40px",
                        padding: "8px",
                        margin: "5px 10px 20px",
                        marginTop: "10px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        border: "1px solid #000",
                        borderRadius: "20px",
                      }}
                    >
                      <input
                        type="email"
                        placeholder=" Email"
                        style={{ border: "none" }}
                        className="w-100 text-center-mobile"
                        {...register("Email", {
                          required: true,
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "invalid email address",
                          },
                        })}
                      />
                      {errors.Email && (
                        <span className="text-danger auth-validation-span">
                          Email is required and format should be valid
                        </span>
                      )}
                    </div>
                    <div
                      className="auth-validation-div"
                      style={{
                        height: "40px",
                        padding: "8px",
                        margin: "5px 10px 20px",
                        marginTop: "10px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        border: "1px solid #000",
                        borderRadius: "20px",
                      }}
                    >
                      <div className="pr-2 d-flex align-items-center">
                        <svg
                          width={31}
                          height={30}
                          viewBox="0 0 31 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.0083 29.8114C23.2886 29.8114 30.0011 23.1539 30.0011 14.9414C30.0011 6.72885 23.2886 0.0712891 15.0083 0.0712891C6.72809 0.0712891 0.015625 6.72885 0.015625 14.9414C0.015625 23.1539 6.72809 29.8114 15.0083 29.8114Z"
                            fill="#F0F0F0"
                          />
                          <path
                            d="M8.55469 20.2178L9.86998 29.0672C13.6317 30.4476 17.792 30.2911 21.4374 28.6319C25.0828 26.9727 27.9154 23.9465 29.3132 20.2178H8.55469Z"
                            fill="black"
                          />
                          <path
                            d="M8.55469 9.78162L9.86998 0.932157C13.6314 -0.447474 17.791 -0.290494 21.4359 1.36864C25.0807 3.02778 27.9129 6.05349 29.3107 9.78162H8.55469Z"
                            fill="#6DA544"
                          />
                          <path
                            d="M8.06025e-10 14.9987C-3.18685e-05 18.0616 0.944996 21.0512 2.70814 23.5658C4.47128 26.0805 6.96809 27.9997 9.86317 29.0658V0.932129C6.96817 1.99817 4.47142 3.91736 2.70829 6.4319C0.945148 8.94643 7.18711e-05 11.9359 8.06027e-10 14.9987H8.06025e-10Z"
                            fill="#A2001D"
                          />
                        </svg>
                        +971
                      </div>
                      <input
                        type="text"
                        placeholder="Phone Number"
                        onKeyDown={(e) => {
                          const isCtrlKey = e.ctrlKey || e.metaKey; // Check if "ctrl" or "cmd" key is pressed
                          const keyValue = e.key;
                          const numericRegex = /^[0-9]*$/;
                          const isEnterKey = e.key === "Enter";
                          if (
                            !(
                              numericRegex.test(keyValue) ||
                              isCtrlKey ||
                              keyValue === "Backspace" ||
                              isEnterKey
                            )
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const pastedValue = e.clipboardData.getData("text");
                          const numericRegex = /^[0-9]*$/;
                          if (!numericRegex.test(pastedValue)) {
                            e.preventDefault();
                          }
                        }}
                        onInput={(e) => {
                          if (e.target.value.length > e.target.maxLength) {
                            e.target.value = e.target.value.slice(
                              0,
                              e.target.maxLength
                            );
                          }
                        }}
                        maxLength={9}
                        style={{ border: "none" }}
                        className="w-100"
                        {...register("phoneNumber", {
                          required: true,
                          validate: (value) =>
                            value[0] === "5" && value.length === 9,
                        })}
                      />
                      {errors.phoneNumber && (
                        <span className="text-danger auth-validation-span">
                          Enter valid phone number
                        </span>
                      )}
                    </div>
                    <div
                      className="auth-validation-div"
                      style={{
                        height: "40px",
                        padding: "8px",
                        margin: "10px 10px 20px",
                        marginTop: "10px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        border: "1px solid #000",
                        borderRadius: "20px",
                      }}
                    >
                      <input
                        type="text"
                        placeholder=" Referral Code (Optional)"
                        style={{ border: "none" }}
                        className="w-100 text-center-mobile"
                        {...register("RefferalCode", { required: false })}
                      />
                    </div>
                    <button
                      className="button-submit btn-login shine-animation-new"
                      style={{ border: "none", marginLeft: "30px" }}
                      type="submit"
                      disabled={isSubmitting}
                    >
                      Sign Up
                      {isSubmitting && (
                        <Spinner
                          animation="grow"
                          role="status"
                          className="ml-2"
                          size="sm"
                        >
                          <span className="visually-hidden"></span>
                        </Spinner>
                      )}
                    </button>
                    <a
                      className="text-center"
                      style={{
                        margin: "5px",
                        cursor: "auto",
                        color: "#8a3c90",
                      }}
                    >
                      Already a member?
                      <span
                        className="text-primary"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setIsLoginSection(true);
                          setVerifyOtpSection(false);
                          setShow(true);
                        }}
                      >
                        {" "}
                        LOGIN
                      </span>
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        ) : (
          <div style={{ height: "35vh" }} />
        )}
      </Container>
      <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{"LOGIN"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {verifyOtpSection ? (
            <div className="container text-center">
              <VerifyOTP
                resendOtp={resendOtp}
                onOTPVerify={onOTPVerify}
                handleSubmit={handleSubmit}
                register={register}
                errors={errors}
                isSubmitting={isSubmitting}
                otpValid={otpValid}
                setOtpValid={setOtpValid}
                phoneNumber={phoneNumber}
                setVerifyOtpSection={setVerifyOtpSection}
                isCheckout={true}
              />{" "}
            </div>
          ) : null}
          {isLoginSection && !verifyOtpSection ? (
            <form onSubmit={handleSubmit(onLoginSubmit)}>
              <div className="container text-center">
                <img
                  src="/assets/user.svg"
                  alt="logo"
                  width={120}
                  className="m-2"
                />
                <div
                  className="auth-validation-div mb-3"
                  style={{
                    height: "40px",
                    padding: "8px",
                    margin: "5px 30px",
                    marginTop: "10px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    border: "1px solid #000",
                    borderRadius: "20px",
                  }}
                >
                  <div className="pr-2 d-flex align-items-center">
                    {" "}
                    <svg
                      width={31}
                      height={30}
                      viewBox="0 0 31 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.0083 29.8114C23.2886 29.8114 30.0011 23.1539 30.0011 14.9414C30.0011 6.72885 23.2886 0.0712891 15.0083 0.0712891C6.72809 0.0712891 0.015625 6.72885 0.015625 14.9414C0.015625 23.1539 6.72809 29.8114 15.0083 29.8114Z"
                        fill="#F0F0F0"
                      />
                      <path
                        d="M8.55469 20.2178L9.86998 29.0672C13.6317 30.4476 17.792 30.2911 21.4374 28.6319C25.0828 26.9727 27.9154 23.9465 29.3132 20.2178H8.55469Z"
                        fill="black"
                      />
                      <path
                        d="M8.55469 9.78162L9.86998 0.932157C13.6314 -0.447474 17.791 -0.290494 21.4359 1.36864C25.0807 3.02778 27.9129 6.05349 29.3107 9.78162H8.55469Z"
                        fill="#6DA544"
                      />
                      <path
                        d="M8.06025e-10 14.9987C-3.18685e-05 18.0616 0.944996 21.0512 2.70814 23.5658C4.47128 26.0805 6.96809 27.9997 9.86317 29.0658V0.932129C6.96817 1.99817 4.47142 3.91736 2.70829 6.4319C0.945148 8.94643 7.18711e-05 11.9359 8.06027e-10 14.9987H8.06025e-10Z"
                        fill="#A2001D"
                      />
                    </svg>{" "}
                    +971
                  </div>
                  <input
                    type="text"
                    placeholder="Phone Number"
                    onKeyDown={(e) => {
                      const isCtrlKey = e.ctrlKey || e.metaKey; // Check if "ctrl" or "cmd" key is pressed
                      const keyValue = e.key;
                      const numericRegex = /^[0-9]*$/;
                      const isEnterKey = e.key === "Enter";
                      if (
                        !(
                          numericRegex.test(keyValue) ||
                          isCtrlKey ||
                          keyValue === "Backspace" ||
                          isEnterKey
                        )
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onPaste={(e) => {
                      const pastedValue = e.clipboardData.getData("text");
                      const numericRegex = /^[0-9]*$/;
                      if (!numericRegex.test(pastedValue)) {
                        e.preventDefault();
                      }
                    }}
                    onInput={(e) => {
                      if (e.target.value.length > e.target.maxLength) {
                        e.target.value = e.target.value.slice(
                          0,
                          e.target.maxLength
                        );
                      }
                    }}
                    maxLength={9}
                    style={{ border: "none" }}
                    className="w-100"
                    {...register("phoneNumber", {
                      required: true,
                      validate: (value) =>
                        value[0] === "5" && value.length === 9,
                    })}
                  />
                  {errors.phoneNumber && (
                    <span className="text-danger auth-validation-span">
                      Enter valid phone number
                    </span>
                  )}
                </div>

                <button
                  className="button-submit btn-login shine-animation-new"
                  style={{
                    border: "none",
                    background: "black",
                    color: "white",
                  }}
                  type="submit"
                  disabled={isSubmitting}
                >
                  Login
                  {isSubmitting && (
                    <Spinner
                      animation="grow"
                      role="status"
                      className="ml-2"
                      size="sm"
                    >
                      <span className="visually-hidden"></span>
                    </Spinner>
                  )}
                </button>
                <a
                  className="text-center"
                  style={{ margin: "5px", cursor: "auto", color: "#8a3c90" }}
                >
                  If you don't have a account,
                  <span
                    className="text-primary"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      onHide();
                    }}
                  >
                    {" "}
                    Sign Up
                  </span>
                </a>
              </div>
            </form>
          ) : null}
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    loginData: state.loginData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserAuth: () => {
      dispatch(getUserAuth());
    },
    setAuth: (data) => {
      dispatch(setAuth(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpPage);
